import React from 'react';
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

/**
 * パンくずリストコンポーネント
 * @param {Object} props
 * @param {Array} props.items - パンくずリスト項目 [{name: string, path: string}]
 * @param {Object} props.sx - スタイルのオーバーライド
 */
const Breadcrumbs = ({ items = [], sx = {} }) => {
    if (!items || items.length === 0) return null;

    return (
        <Box sx={{ my: 2, ...sx }}>
            <MuiBreadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="パンくずリスト"
            >
                <Link
                    underline="hover"
                    color="inherit"
                    component={RouterLink}
                    to="/"
                    sx={{ display: 'flex', alignItems: 'center' }}
                >
                    <HomeIcon sx={{ mr: 0.5, fontSize: 20 }} />
                    トップ
                </Link>

                {items.slice(1).map((item, index) => {
                    const isLast = index === items.length - 2;

                    return isLast ? (
                        <Typography key={index} color="text.primary" aria-current="page">
                            {item.name}
                        </Typography>
                    ) : (
                        <Link
                            key={index}
                            underline="hover"
                            color="inherit"
                            component={RouterLink}
                            to={item.path}
                        >
                            {item.name}
                        </Link>
                    );
                })}
            </MuiBreadcrumbs>
        </Box>
    );
};

export default Breadcrumbs; 